// theme.js

document.addEventListener('DOMContentLoaded', function() {
  // Find all product details sections
  const productDetailsSections = document.querySelectorAll('.hdt-product-details');

  productDetailsSections.forEach(section => {
    const scrollContainer = section.querySelector('.hdt-product-details__scroll-container');
    const prevBtn = section.querySelector('.hdt-product-details__prev-btn');
    const nextBtn = section.querySelector('.hdt-product-details__next-btn');

    // If all necessary elements are found, add the click event listeners
    if (scrollContainer && prevBtn && nextBtn) {
      // Function to scroll left
      prevBtn.addEventListener('click', () => {
        scrollContainer.scrollBy({ left: -300, behavior: 'smooth' });
      });

      // Function to scroll right
      nextBtn.addEventListener('click', () => {
        scrollContainer.scrollBy({ left: 300, behavior: 'smooth' });
      });
    }
  });
});
